import { useTranslation } from 'react-i18next';
import { SettingsHeader } from '../../../../components/layout/settings-header/settings-header';
import '../../settings-page.scss';
import { SettingsRow } from '../settings-row/settings-row';
import { Switch } from 'antd';
import { BookrWpOptions, BookrWpOptionsNotifications } from '../../../../core/models/bookr-wp-options';
import { useEffect, useState } from 'react';

type NotificationSettingsProps = {
	bookrWpOptions?: BookrWpOptions;
	onClickSave: () => void;
	onChange: (bookrWpOptions: BookrWpOptions) => void;
};

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({ bookrWpOptions, onClickSave, onChange }) => {
	const { t } = useTranslation();

	const [notifications, setNotifications] = useState<BookrWpOptionsNotifications>({
		sendCustomerRequestMail: window.bookrPluginData.notifications.sendCustomerRequestMail,
		sendAdminRequestMail: window.bookrPluginData.notifications.sendAdminRequestMail,
		sendCustomerAcceptedMail: window.bookrPluginData.notifications.sendCustomerAcceptedMail,
		sendCustomerRejectedMail: window.bookrPluginData.notifications.sendCustomerRejectedMail,
	});

	useEffect(() => {
		if (!bookrWpOptions) return;

		const updateBookrOptions: BookrWpOptions = {
			...bookrWpOptions,
			notifications: notifications,
		};

		onChange(updateBookrOptions);
	}, [notifications]);

	const handleChange = (key: any) => (checked: boolean) => {
		setNotifications((prev) => ({
			...prev,
			[key]: checked,
		}));
	};

	return (
		<>
			<SettingsHeader title={t('backEnd.settings.notification.title')} onClickSave={onClickSave} />

			<SettingsRow title={t('backEnd.settings.notification.sendCustomerRequestMail')}>
				<Switch value={notifications?.sendCustomerRequestMail} onChange={handleChange('sendCustomerRequestMail')} />
			</SettingsRow>
			<SettingsRow title={t('backEnd.settings.notification.sendAdminRequestMail')}>
				<Switch value={notifications?.sendAdminRequestMail} onChange={handleChange('sendAdminRequestMail')} />
			</SettingsRow>
			<SettingsRow title={t('backEnd.settings.notification.sendCustomerAcceptedMail')}>
				<Switch value={notifications?.sendCustomerAcceptedMail} onChange={handleChange('sendCustomerAcceptedMail')} />
			</SettingsRow>
			<SettingsRow title={t('backEnd.settings.notification.sendCustomerRejectedMail')}>
				<Switch value={notifications?.sendCustomerRejectedMail} onChange={handleChange('sendCustomerRejectedMail')} />
			</SettingsRow>
		</>
	);
};
